export default {
    isPc() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
            return false
        } else {
            return true
        }
    },
    calAllSize(width, height) {
        let scale = this.calScale()
        let newWidth = scale * width
        let newHeight = scale * height
        return "width:" + newWidth + "px;height:" + newHeight + "px;"
    },
    calWidth(width) {
        let scale = this.calScale()
        let newWidth = scale * width
        return "width:" + newWidth + "px;"
    },
    calHeight(height) {
        let scale = this.calScale()
        let newHeight = scale * height
        return "height:" + newHeight + "px;"
    },
    calSize() {
        // let scale = this.calScale()
        // return scale * 16 + "px;"
        return "1px;"
    },
    calScale() {
        if (this.isPc()) {
            return 1;
        } else {
            let width = window.screen.width
            return width / 1200
        }
    },
}

